import { defaultApiClient } from "../../core/components/HttpClient";
import { Api } from "../../core/components/Api";

export const enum BannerSize {
    TOP = "TOP",
    SIDEBAR = "SIDEBAR",
    CONTENT = "CONTENT"
}

interface BannerItemRequest {
    position: BannerSize,
    qty: number,
}

export interface BannerItem {
    id: number,
    name: string,
    description: string,
    image: string,
    position: number,
    url: string,
    view: number,
    click: number,
    public_image: string
}

export interface BannerItemsResponse {
    TOP: Array<BannerItem>,
    SIDEBAR: Array<BannerItem>,
    CONTENT: Array<BannerItem>,
}

defaultApiClient.setPrefix("/api");

export class BannerApi extends Api {
    getBanners = async (items: string): Promise<BannerItemsResponse> => {
        this.showLoader();
        return await defaultApiClient.request({
            url: "/banners/list?"+items,
            method: "GET"
        })
            .then((response) => {
                const data = response.data;
                return data;
            })
            .catch((error) => {
                return error;
            });
    }
}